import styled from 'styled-components';

export const Splitter = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid silver;
`